import { render } from "./PortfolioBody.vue?vue&type=template&id=5fcca11c"
import script from "./PortfolioBody.vue?vue&type=script&lang=js"
export * from "./PortfolioBody.vue?vue&type=script&lang=js"

import "./PortfolioBody.vue?vue&type=style&index=0&id=5fcca11c&lang=css"
script.render = render

export default script